<button *ngIf="show" pButton (click)="sync()" [disabled]="syncLoading" label="" [icon]="syncLoading ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'" class="p-button-sm"></button>
